module.exports = __webpack_public_path__ + "img/logoMenu.228d873e.png";